import {useState, useRef} from "react";

export const useSetIframeHeight = (isStaticHeight = false, iframeHeight = 10000) => {
  //Importante definir un valor alto para usar hashtag para hacer scroll dentro de iframes
  const [height, setHeight] = useState(iframeHeight);
  const innerRef = useRef(null);
  
  const handleResizeHeight = () => {
    if(isStaticHeight) {
      setHeight(iframeHeight);
      return;
    }
    const {body} = innerRef.current.contentWindow.document;
    const contentHeight = Math.max(
      body.clientHeight,
      body.offsetHeight,
      body.scrollHeight
    );
    
    if (contentHeight !== height) {
      setHeight(contentHeight);
    }
  };
  
  return [height, innerRef, handleResizeHeight]
}